<section class="about" id="about" aria-labelledby="about-heading">
  <div class="about__content-wrapper">
    <div class="about__image">
      <img
      width="120"
      height="120"
      loading="lazy"
      decoding="async"
        src="hueseyin-korkut.webp"
        alt="Hüseyin Korkut Profilbild"
      />
    </div>
    <div class="about__content">
      <h2 id="about-heading">{{ 'ABOUT.HEADLINE' | translate }}</h2>

      <p>
        {{ 'ABOUT.INTRO' | translate }}
      </p>

      <p innerHTML="{{ 'ABOUT.MISSION' | translate }}"></p>

      <p>
        <em>{{ 'ABOUT.MOTTO' | translate }}</em>
      </p>
    </div>
  </div>
</section>
